

// export default function Installment() 


import "./NewEngineering.css";
import { NavLink } from "react-router-dom";
import Avatar1 from '../Images/newin.png'
import Aboutbg from '../Images/new_install.jpeg'
import Footer from "../Component/NewFooter";

const services = [
  {
    id: "valves",
    label: "Valves Asset Management",
    title: "Our installation scope covers mechanical and electrical installation of field instruments, control valves, analyzers, junction boxes, impulse tubing, instrument air systems, and cable trays.",
    intro:
      "Jeyshawn Engineering Limited delivers comprehensive Installation and Instrumentation solutions for the oil & gas, energy, marine, and industrial sectors. We specialize in the installation, calibration, testing, commissioning, and maintenance of industrial equipment, instrumentation systems, and process control facilities designed to improve operational efficiency, safety, reliability, and productivity.",

    intro1:
      "Backed by a team of experienced engineers, instrumentation specialists, and technical professionals, we provide integrated solutions tailored to meet the specific operational and project requirements of our clients. Our services are executed in compliance with international engineering standards, industry regulations, and strict Health, Safety, and Environment (HSE) procedures.",
      
    intro2:
      "We provide installation services for mechanical, electrical, and process systems, including pipelines, pumps, valves, process skids, control panels, cable systems, and industrial equipment for both onshore and offshore facilities. Our expertise also covers instrumentation installation involving pressure, temperature, flow, and level instruments, control valves, gas detection systems, PLCs, SCADA systems, and industrial automation solutions that support accurate monitoring and efficient process control.",

    intro3:
      "Through innovation, technical excellence, and commitment to reliable delivery service, Jeyshawn Engineering Limited continues to provide dependable Installation and Instrumentation solutions that support industrial growth and operational success across diverse sectors.",
      

  }
];

 const servicesNav = [
  { label: "Engineering",                    href: "/engineering" },
  { label: "Procurement",                    href: "/procurement" },
  { label: "Construction & Camp Setup",                   href: "/construction" },
  { label: "Installation & Instrumentation", href: "/installation-instrumentation" },
  { label: "Commissioning",                  href: "/commissioning" },
  { label: "Manpower-supply",                 href: "/manpower-supply" },
  { label: "Marine Support",                 href: "/marine-support" },
];


export default function Installments() {
  return (
    <>
      <div className="img_carrierins">
        <img src={Avatar1} alt="" />
      </div>

      <section className="service-detail" style={{ backgroundImage: `url(${Aboutbg})` }}>
        <div className="service-detail__layout">

          {/* Left — Content (your existing JSX, unchanged) */}
          <div className="service-detail__content">
            <h2 className="service-detail__title">{services[0].title}</h2>
            <span className="service-detail__divider" />
            <p className="service-detail__intro">{services[0].intro}</p>
            <p className="service-detail__intro">{services[0].intro1}</p>
            <p className="service-detail__intro">{services[0].intro2}</p>
            <p className="service-detail__intro">{services[0].intro3}</p>
            {/* {services[0].sections.map((sec, i) => (
              <div key={i} className="service-detail__section">
                <h3 className="service-detail__section-heading">{sec.heading}</h3>
                <ul className="service-detail__list">
                  {sec.items.map((item, j) => (
                    <li key={j} className="service-detail__list-item">{item}</li>
                  ))}
                </ul>
              </div>
            ))} */}
          </div>

          {/* Right — Nav links instead of state buttons */}
          <nav className="service-detail__tabs" aria-label="Service navigation">
            {servicesNav.map((s) => (
              <NavLink
                key={s.href}
                to={s.href}
                className={({ isActive }) =>
                  `service-detail__tab${isActive ? " service-detail__tab--active" : ""}`
                }
              >
                {s.label}
              </NavLink>
            ))}
          </nav>

        </div>
      </section>
      <Footer/>
    </>
  );
}


 